// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2sqXz","visibleHandle":"Handle_visibleHandle__kd730","dragged":"Handle_dragged__1YJPs"};